import AuthModule from './module'
import { AUTH_NAMESPACE } from './module/types'
import idAuthenticator from './id/smart-id-auth'

/**
 * Implements a vue plugin and vuex plugin for authenticating your application
 * against SMART ID
 *
 * See: <https://confluence.smarttech.com/display/LAB/vue-smart-auth> for usage.
 */

let _auth
let _store

// SMART ID authenticator is provided as part of this plugin.
export { idAuthenticator }

export default {
  /**
   * install entry-point function for a Vue plugin
   */
  install(Vue) {
    _auth = {}
    Vue.prototype.$auth = _auth
  },

  /**
   * plugin entry-point function for a Vuex plugin
   */
  plugin(store) {
    _store = store
    if (!_store.state.auth) {
      _store.registerModule('auth', AuthModule)
    }
  },

  /**
   * Must be called and resolved before new Vue()
   */
  loadAuthenticators(config) {
    const initPromises = []

    config.authenticators.forEach(authenticator => {
      let authenticatorName = authenticator.getName()
      let authenticatorModule = authenticator.getStoreModule()

      // Expose $auth.<authenticatorName>
      _auth[authenticatorName] = authenticator

      if (!_store.state[AUTH_NAMESPACE][authenticatorName]) {
        _store.registerModule([AUTH_NAMESPACE, authenticatorName], authenticatorModule)
      }

      let initPromise = authenticator.load(_store)
      initPromises.push(initPromise)
    })

    return Promise.all(initPromises)
  },
  load() {
    const loadPromises = Object.values(_auth).map(authenticator => authenticator.load())
    return Promise.all(loadPromises)
  }
}
